// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SharePermissionComponent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Share Permission Component
 */

import React, { Component } from 'react';
import { propTypes as MobxPropTypes } from 'mobx-react';

import EventsUtils from 'EventUtils';
import Validator from 'share/components/hoc/Izenda.Validator';
import connect from 'share/enhancers/Izenda.Connect';
import CONSTANT from 'logic/data/Izenda.AccessConstants';
import ControlBySharePermission from './Izenda.ControlBySharePermission';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import DropDown from 'share/components/controls/Izenda.DropDown';
import { initial } from 'lodash/fp';

const ValidatorDropDown = Validator()(DropDown);
const notifyChange = EventsUtils.notifyChange;

@connect()
export default class SharePermissionComponent extends Component {
  static propTypes = {
    data: React.PropTypes.object,
    store: MobxPropTypes.observableObject,
    users: MobxPropTypes.arrayOrObservableArray,
    roles: MobxPropTypes.arrayOrObservableArray
  };

  render() {
    const props = this.props;
    const { data = {}, isGlobal } = props;
    const assignType = isGlobal ? initial(CONSTANT.ASSIGNED_TYPE) : CONSTANT.ASSIGNED_TYPE;
    const onChange = notifyChange(props.change, EventsUtils.DROPDOWN);

    return (
      <GridLayout.Row className="u_noBorder">
        <GridLayout.Col cols="3" className="u_noBorder">
          <ValidatorDropDown
            field="assignType"
            group={data.tempId}
            validations={CONSTANT.CONSTRAINTS.SHARE_WITH}
            blankOption
            options={assignType}
            value={data.assignedType}
            valueField="value"
            labelField="label"
            onChange={onChange}
            disabled={props.readOnly}
          />
        </GridLayout.Col>
        <GridLayout.Col cols="9" className="u_noBorder">
          <ControlBySharePermission
            data={props.data}
            selectedValue={data.assignedType}
            store={props.store}
            users={props.users}
            roles={props.roles}
            loadUsers={props.loadUsers}
            loadRoles={props.loadRoles}
            readOnly={props.readOnly}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Access/Izenda.SharePermissionComponent.jsx